module.exports = __webpack_public_path__ + "static/img/course.5184ddc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/course.png
// module id = zPRm
// module chunks = 1